import { useEffect, useState } from 'react'

/**
 * Yoğun/çok kolonlu tabloların kart listesine döndüğü ortak eşik. Yalnız telefon değil **tablet
 * portre** genişlikleri de kapsar (iPad Mini 768 / Air 820 / Pro 11" 834 / Pro 12.9" 1024) — kullanıcı
 * geri bildirimi 2026-08-20: kenar çubuğu görünürken (>768px'te gizlenmiyor) `tk-table-fit`in yüzde
 * kolonları bu genişliklerde piksel olarak o kadar daralıyordu ki başlıklar TEK KELİMEYİ bile
 * sığdıramayıp harf harf bölünüyordu (`.act-th-tight` gibi nokta atışı düzeltmeler yetmiyordu — sorun
 * birkaç dar kolonla sınırlı değildi, TÜM kolonlarda tekrarlanıyordu). Kart görünümü herhangi bir
 * genişlikte zaten iyi çalıştığından (320-1024px arası ekran görüntüleriyle doğrulandı), eşiği masaüstü
 * düzenin gerçekten rahat olduğu noktaya (kenar çubuğu 252px + tablo en az ~700-800px kalacak şekilde)
 * çekmek, tabloyu yeniden yazmadan sorunu kökten çözer. 1024px'in ÜSTÜ (dizüstü/masaüstü) değişmez.
 */
export const CARD_VIEW_BREAKPOINT = '(max-width: 1024px)'

/**
 * Paylaşılan `matchMedia` sarmalayıcı (Reuse Mandate) — sayfa genişliği bir kırılım noktasını
 * geçtiğinde bileşenin **render dalını** değiştirmesi gerektiğinde kullanılır (ör. yoğun bir tabloyu
 * telefon/tablet genişliğinde kart listesine çevirmek — salt CSS'in çözemeyeceği durumlar, bkz.
 * `DashboardActionsCard`/`ActionsListPanel` mobil kart görünümü).
 *
 * jsdom (vitest) `matchMedia`'yı gerçek düzen yapmadan sağlar (`test/setup.ts` stub'ı — her zaman
 * `matches:false` döner) → testlerde bileşen daima masaüstü dalını render eder, mevcut testler bu
 * yüzden etkilenmez.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches)

  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = () => setMatches(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}
